/* eslint-disable class-methods-use-this */
import { PagedResultDto } from '../dto/pagedResultDto';
import http from '../httpInfrastructureService';
import {
  CreateVehicle,
  MotHistory,
  PagedUserVehicleDto,
  PagedVehicle,
  RefreshVehicleData,
  UpdateVehicle,
  UpdateVehicleMileage,
  UserVehicle,
  UserVehicleRequestDto,
  Vehicle,
} from './dto/vehicle';

class VehicleService {
  public async getAll(request: PagedVehicle): Promise<PagedResultDto<Vehicle>> {
    const result = await http.get('api/services/app/Vehicle/GetAll', {
      params: request,
    });
    return result.data.result;
  }

  public async getByRegistrationNumber(registrationNumber: string): Promise<Vehicle> {
    const result = await http.get(`api/services/app/Vehicle/GetByRegistrationNumber`, {
      params: { registrationNumber },
    });
    return result.data.result;
  }

  public async create(vehicle: CreateVehicle): Promise<Vehicle> {
    const result = await http.post('api/services/app/Vehicle/Create', vehicle);
    return result.data.result;
  }

  public async update(vehicle: UpdateVehicle): Promise<Vehicle> {
    const result = await http.put('api/services/app/Vehicle/Update', vehicle);
    return result.data.result;
  }

  public async refreshVehicleData(request: RefreshVehicleData): Promise<Vehicle> {
    const result = await http.post('api/services/app/Vehicle/RefreshVehicleData', request);
    return result.data.result;
  }

  public async updateVehicleMileage(vehicle: UpdateVehicleMileage): Promise<Vehicle> {
    const result = await http.put('api/services/app/Vehicle/UpdateVehicleMileage', vehicle);
    return result.data.result;
  }

  public async checkVehicleMileage(vehicle: UpdateVehicleMileage): Promise<boolean> {
    const result = await http.post('api/services/app/Vehicle/CheckVehicleMileage', vehicle);
    return result.data.result;
  }

  public async createCustom(vehicle: CreateVehicle): Promise<Vehicle> {
    const result = await http.post('api/services/app/Vehicle/CreateCustom', vehicle);
    return result.data.result;
  }

  public async getUserVehicles(request: PagedUserVehicleDto): Promise<PagedResultDto<UserVehicle>> {
    const result = await http.get('api/services/app/UserVehicle/GetAll', {
      params: request,
    });
    return result.data.result;
  }

  public async getUserVehicle(request: UserVehicleRequestDto): Promise<UserVehicle> {
    const result = await http.get('api/services/app/UserVehicle/GetUserVehicle', {
      params: request,
    });
    return result.data.result;
  }

  public async getMotHistory(registrationNumber: string): Promise<MotHistory> {
    const result = await http.get(
      `/api/services/app/Vehicle/GetMotHistoryByRegistrationNumber?registrationNumber=${registrationNumber}`
    );
    return result.data.result;
  }

  public async getMotHistoryByVin(vin: string): Promise<MotHistory> {
    const result = await http.get(`/api/services/app/Vehicle/GetMotHistoryByVinNumber?vin=${vin}`);
    return result.data.result;
  }

  public async getByVin(vin: string): Promise<Vehicle> {
    const result = await http.get('api/services/app/Vehicle/GetByVin', {
      params: { vin },
    });
    return result.data.result;
  }
}

export default new VehicleService();
